<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005eff"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="#FC4B4B" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center>
      <v-flex
        xs12
        text-center
        style="
          background-color: #f8f8f8;
          font-family: sofiaPro;
          font-size: 11px;
        "
      >
        <v-btn :ripple="false" text style="text-transform: none"
          ><span style="color: #acacac">Primary Details </span></v-btn
        >
        <v-btn :ripple="false" text style="text-transform: none">
          <span style="color: black; border-bottom: 2px solid #3460e1">
            Services & Working Hours
          </span>
        </v-btn>
        <v-btn :ripple="false" text style="text-transform: none">
          <span style="color: #acacac">Bank Details </span></v-btn
        >
        <v-btn :ripple="false" text style="text-transform: none">
          <span style="color: #acacac"> Documents </span>
        </v-btn>
      </v-flex>
      <v-flex xs12 md10 lg6 py-3>
        <v-card with="100%">
          <v-layout wrap py-8>
            <v-flex
              xs12
              text-center
              style="font-family: sofiaPro; font-size: 20px"
              >Services & Working Hours</v-flex
            >
            <v-flex xs12 px-2 text-left>
              <span style="font-family: sofiaPro">Category</span>
              <v-select
                class="rounded"
                dense
                outlined
                v-model="categoryType"
                :items="category"
                item-text="name"
                item-value="_id"
              >
              </v-select>
            </v-flex>
            <v-flex xs12 px-2 text-left>
              <span style="font-family: sofiaPro">Subcategory</span>
              <v-select
                class="rounded"
                dense
                outlined
                multiple
                v-model="subcategoryType"
                :items="subcategory"
                item-text="name"
                item-value="_id"
              >
              </v-select>
            </v-flex>
            <v-flex
              xs12
              px-2
              text-left
              v-if="categoryType == '601e2b174b2e12e49fd4da3c'"
            >
              <span style="font-family: sofiaPro">Restaurant Type</span>
              <v-select
                class="rounded"
                dense
                outlined
                multiple
                v-model="restaurantType"
                :items="restaurant"
                item-text="name"
                item-value="_id"
              >
              </v-select>
            </v-flex>
            <!--
              new fields for number of chairs
              -->
            <v-flex
              xs12
              px-2
              text-left
              v-if="categoryType == '601e2b174b2e12e49fd4da3c'"
            >
              <v-switch
                v-model="isBookingAvailable"
                label="isBookingAvailable"
              ></v-switch>
            </v-flex>
            <v-flex text-left xs12 px-2 v-if="isBookingAvailable == true">
              <span style="font-family: sofiaPro">No of Chairs</span>

              <v-text-field
                outlined
                class="rounded"
                type="number"
                v-model="numberofChairs"
                dense
              >
              </v-text-field>
            </v-flex>

            <!--
                end of number of chairs
              -->
            <v-flex xs12 px-2 text-left>
              <v-switch v-model="is24x7" label="is24x7"></v-switch>
            </v-flex>
            <v-flex xs12 px-2 text-left>
              <v-layout wrap style="font-family: sofiaPro">
                <v-flex xs6 text-left> <span>Working Hour</span> </v-flex>
                <v-flex xs3 text-center> <span>Opening Time</span> </v-flex>
                <v-flex xs3 text-center> <span>Closing Time</span> </v-flex>
              </v-layout>
            </v-flex>
            <v-flex px-2>
              <v-layout wrap>
                <v-flex xs2 sm1 align-self-end text-left>
                  <v-switch :disabled="is24x7" v-model="sun.working"></v-switch>
                </v-flex>
                <v-flex xs4 sm5 align-self-center text-left>
                  <h3
                    style="font-family: sofiaPro; color: black; font-size: 13px"
                  >
                    SUNDAY
                  </h3>
                </v-flex>
                <v-flex xs3 text-center>
                  <v-menu
                    ref="menu1"
                    v-model="sun.sun1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="sun.open"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="!sun.working"
                        v-model="sun.open"
                        label="Opening Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="sun.sun1"
                      v-model="sun.open"
                      full-width
                      @click:minute="$refs.menu1.save(sun.open)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs3 text-right>
                  <v-menu
                    ref="menu2"
                    v-model="sun.sun2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="sun.close"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="!sun.working"
                        v-model="sun.close"
                        label="Closing Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="sun.sun2"
                      :rules="rule"
                      v-model="sun.close"
                      full-width
                      @click:minute="$refs.menu2.save(sun.close)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex px-2>
              <v-layout wrap>
                <v-flex xs2 sm1 align-self-end text-left>
                  <v-switch :disabled="is24x7" v-model="mon.working"></v-switch>
                </v-flex>
                <v-flex xs4 sm5 align-self-center text-left>
                  <h3
                    style="font-family: sofiaPro; color: black; font-size: 13px"
                  >
                    MONDAY
                  </h3>
                </v-flex>
                <v-flex xs3 text-center>
                  <v-menu
                    ref="menu3"
                    v-model="mon.mon1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="mon.open"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="!mon.working"
                        v-model="mon.open"
                        label="Opening Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="mon.mon1"
                      v-model="mon.open"
                      full-width
                      @click:minute="$refs.menu3.save(mon.open)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs3 text-right>
                  <v-menu
                    ref="menu4"
                    v-model="mon.mon2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="mon.close"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="!mon.working"
                        v-model="mon.close"
                        label="Closing Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="mon.mon2"
                      :rules="rule"
                      v-model="mon.close"
                      full-width
                      @click:minute="$refs.menu4.save(mon.close)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex px-2>
              <v-layout wrap>
                <v-flex xs2 sm1 text-left align-self-end>
                  <v-switch :disabled="is24x7" v-model="tue.working"></v-switch>
                </v-flex>
                <v-flex align-self-center xs4 sm5 text-left>
                  <h3
                    style="font-family: sofiaPro; color: black; font-size: 13px"
                  >
                    TUESDAY
                  </h3>
                </v-flex>
                <v-flex xs3 text-center>
                  <v-menu
                    ref="menu5"
                    v-model="tue.tue1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="tue.open"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="!tue.working"
                        v-model="tue.open"
                        label="Opening Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="tue.tue1"
                      v-model="tue.open"
                      full-width
                      @click:minute="$refs.menu5.save(tue.open)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs3 text-right>
                  <v-menu
                    ref="menu6"
                    v-model="tue.tue2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="tue.close"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="!tue.working"
                        v-model="tue.close"
                        label="Closing Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="tue.tue2"
                      :rules="rule"
                      v-model="tue.close"
                      full-width
                      @click:minute="$refs.menu6.save(tue.close)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex px-2>
              <v-layout wrap>
                <v-flex xs2 sm1 align-self-end text-left>
                  <v-switch :disabled="is24x7" v-model="wed.working"></v-switch>
                </v-flex>
                <v-flex xs4 sm5 align-self-center text-left>
                  <h3
                    style="font-family: sofiaPro; color: black; font-size: 13px"
                  >
                    WEDNESDAY
                  </h3>
                </v-flex>
                <v-flex xs3 text-center>
                  <v-menu
                    ref="menu7"
                    v-model="wed.wed1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="wed.open"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="!wed.working"
                        v-model="wed.open"
                        label="Opening Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="wed.wed1"
                      v-model="wed.open"
                      full-width
                      @click:minute="$refs.menu7.save(wed.open)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs3 text-right>
                  <v-menu
                    ref="menu8"
                    v-model="wed.wed2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="sun.close"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="!wed.working"
                        v-model="wed.close"
                        label="Closing Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="wed.wed2"
                      :rules="rule"
                      v-model="wed.close"
                      full-width
                      @click:minute="$refs.menu8.save(wed.close)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex px-2>
              <v-layout wrap>
                <v-flex xs2 sm1 align-self-end text-left>
                  <v-switch :disabled="is24x7" v-model="thu.working"></v-switch>
                </v-flex>
                <v-flex xs4 sm5 align-self-center text-left>
                  <h3
                    style="font-family: sofiaPro; color: black; font-size: 13px"
                  >
                    THURSDAY
                  </h3>
                </v-flex>
                <v-flex xs3 text-center>
                  <v-menu
                    ref="menu9"
                    v-model="thu.thu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="thu.open"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="!thu.working"
                        v-model="thu.open"
                        label="Opening Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="thu.thu1"
                      v-model="thu.open"
                      full-width
                      @click:minute="$refs.menu9.save(thu.open)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs3 text-right>
                  <v-menu
                    ref="menu10"
                    v-model="thu.thu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="thu.close"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="!thu.working"
                        v-model="thu.close"
                        label="Closing Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="thu.thu2"
                      :rules="rule"
                      v-model="thu.close"
                      full-width
                      @click:minute="$refs.menu10.save(thu.close)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex px-2>
              <v-layout wrap>
                <v-flex xs2 sm1 align-self-end text-left>
                  <v-switch :disabled="is24x7" v-model="fri.working"></v-switch>
                </v-flex>
                <v-flex xs4 sm5 align-self-center text-left>
                  <h3
                    style="font-family: sofiaPro; color: black; font-size: 13px"
                  >
                    FRIDAY
                  </h3>
                </v-flex>
                <v-flex xs3 text-center>
                  <v-menu
                    ref="menu11"
                    v-model="fri.fri1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="fri.open"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="!fri.working"
                        v-model="fri.open"
                        label="Opening Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="fri.fri1"
                      v-model="fri.open"
                      full-width
                      @click:minute="$refs.menu11.save(fri.open)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs3 text-right>
                  <v-menu
                    ref="menu12"
                    v-model="fri.fri2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="fri.close"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="!fri.working"
                        v-model="fri.close"
                        label="Closing Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="fri.fri2"
                      :rules="rule"
                      v-model="fri.close"
                      full-width
                      @click:minute="$refs.menu12.save(fri.close)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex px-2>
              <v-layout wrap>
                <v-flex xs2 sm1 align-self-end text-left>
                  <v-switch :disabled="is24x7" v-model="sat.working"></v-switch>
                </v-flex>
                <v-flex xs4 sm5 align-self-center text-left>
                  <h3
                    style="font-family: sofiaPro; color: black; font-size: 13px"
                  >
                    SATURDAY
                  </h3>
                </v-flex>
                <v-flex xs3 text-center>
                  <v-menu
                    ref="menu13"
                    v-model="sat.sat1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="sat.open"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="!sat.working"
                        v-model="sat.open"
                        label="Opening Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="sat.sat1"
                      v-model="sat.open"
                      full-width
                      @click:minute="$refs.menu13.save(sat.open)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs3 text-right>
                  <v-menu
                    ref="menu14"
                    v-model="sat.sat2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="sat.close"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="!sat.working"
                        v-model="sat.close"
                        label="Closing Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="sat.sat2"
                      :rules="rule"
                      v-model="sat.close"
                      full-width
                      @click:minute="$refs.menu14.save(sat.close)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex>
            <!-- <v-flex px-2>
              <v-layout wrap>
                <v-flex xs2 sm1 align-self-end text-left>
                  <v-switch :disabled="is24x7" v-model="fri.working"></v-switch>
                </v-flex>
                <v-flex xs4 sm5 align-self-center text-left>
                  <h3 style="font-family:sofiaPro; color: black; font-size: 13px">
                    SATURDAY fri
                  </h3>
                </v-flex>
                <v-flex xs3 text-center>
                  <v-menu
                    ref="menufri"
                    v-model="fri.fri1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="fri.open"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="!fri.working"
                        v-model="fri.open"
                        label="Opening Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="fri.fri1"
                      v-model="fri.open"
                      full-width
                      @click:minute="$refs.menufri.save(fri.open)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs3 text-right>
                  <v-menu
                    ref="menu2"
                    v-model="fri.sat2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="fri.close"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="!fri.working"
                        v-model="fri.close"
                        label="Closing Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="fri.sat2"
                      :rules="rule"
                      v-model="fri.close"
                      full-width
                      @click:minute="$refs.menu2.save(fri.close)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-flex> -->
            <v-flex xs12 px-2>
              <v-btn block dark dense color="#E31E24" @click="validate">
                next</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["working", "is24", "uid"],
  components: {},
  data() {
    return {
      numberofChairs: 0,
      isBookingAvailable: false,
      categoryType: null,
      subcategoryType: null,
      restaurantType: null,
      restaurant: [],
      category: [],
      subcategory: [],
      ServerError: false,
      appLoading: false,
      showsnackbar: false,
      msg: null,
      valid: true,
      seller: [],
      is24x7: false,
      WorkingHours: true,
      sun: {
        working: false,
        day: "Sunday",
        open: "",
        close: "",
      },
      mon: {
        working: false,
        day: "Monday",
        open: "",
        close: "",
      },
      tue: {
        working: false,
        day: "Tuesday",
        open: "",
        close: "",
      },
      wed: {
        working: false,
        day: "Wednesday",
        open: "",
        close: "",
      },
      thu: {
        working: false,
        day: "Thursday",
        open: "",
        close: "",
      },
      fri: {
        working: false,
        day: "Friday",
        open: "",
        close: "",
      },
      sat: {
        working: false,
        day: "Saturday",
        open: "",
        close: "",
      },
      data: [],
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      data5: [],
      data6: [],
      rule: [
        (v) =>
          /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(v) ||
          " Required",
      ],
    };
  },
  watch: {
    subcategoryType() {
      console.log("list=", this.subcategoryType);
    },
    categoryType() {
      (this.subcategoryType = null), (this.restaurantType = null);
      if (this.isBookingAvailable == true) {
        this.isBookingAvailable = false;
        this.numberofChairs = 0;
      }
      this.getsubcategory(this.categoryType);
      this.getrestaurant(this.categoryType);
    },
    sun: {
      handler(val) {
        if (!val.working) {
          (val.open = null), (val.close = null);
        }
      },
      deep: true,
    },
    mon: {
      handler(val) {
        if (!val.working) {
          (val.open = null), (val.close = null);
        }
      },
      deep: true,
    },
    tue: {
      handler(val) {
        if (!val.working) {
          (val.open = null), (val.close = null);
        }
      },
      deep: true,
    },
    wed: {
      handler(val) {
        if (!val.working) {
          (val.open = null), (val.close = null);
        }
      },
      deep: true,
    },
    thu: {
      handler(val) {
        if (!val.working) {
          (val.open = null), (val.close = null);
        }
      },
      deep: true,
    },
    fri: {
      handler(val) {
        if (!val.working) {
          (val.open = null), (val.close = null);
        }
      },
      deep: true,
    },
    sat: {
      handler(val) {
        if (!val.working) {
          (val.open = null), (val.close = null);
        }
      },
      deep: true,
    },
  },
  mounted() {
    // this.getData();
    // this.assignData();
    this.getcategory();
  },
  methods: {
    getcategory() {
      axios({
        method: "get",
        url: "category/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.category = response.data.data;
            // var id  = response.data.data
            // this.getsubcategory(id)
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getsubcategory(value) {
      axios({
        method: "get",
        url: "subcategory/list/" + value,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.subcategory = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getrestaurant(value) {
      axios({
        method: "get",
        url: "categorytype/list/" + value,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.restaurant = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    validate() {
      //   if (this.$refs.profileForm.validate()) {
      if (this.subcategoryType && this.categoryType) {
        if (this.isBookingAvailable == true) {
          if (this.numberofChairs >= 1) {
            this.edit();
          } else {
            this.msg = "Please add chair Count";
            this.showsnackbar = true;
          }
        } else {
          this.edit();
        }
      } else {
        this.msg = "Please provide category details";
        this.showsnackbar = true;
      }
      //   }
    },
    // new line of codes
    assignData() {
      this.is24x7 = false;
      //  console.log("gggghhhhiii",this.is24)
      this.sun.open = this.working[0].open;
      this.sun.close = this.working[0].close;
      this.sun.working = this.working[0].working;

      this.mon.open = this.working[1].open;
      this.mon.close = this.working[1].close;
      this.mon.working = this.working[1].working;

      this.tue.open = this.working[1].open;
      this.tue.close = this.working[2].close;
      this.tue.working = this.working[2].working;

      this.wed.open = this.working[3].open;
      this.wed.close = this.working[3].close;
      this.wed.working = this.working[3].working;

      this.thu.open = this.working[4].open;
      this.thu.close = this.working[4].close;
      this.thu.working = this.working[4].working;

      this.fri.open = this.working[5].open;
      this.fri.close = this.working[5].close;
      this.fri.working = this.working[5].working;

      this.sat.open = this.working[6].open;
      this.sat.close = this.working[6].close;
      this.sat.working = this.working[6].working;
    },

    //
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/view/" + this.storage,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.seller = response.data.data.sellerid;
          this.is24x7 = this.seller.is24x7;
          this.data = this.seller.workingHour[0];
          this.sun.open = this.data.open;
          this.sun.close = this.data.close;
          this.sun.working = this.data.working;
          this.data1 = this.seller.workingHour[1];
          this.mon.open = this.data1.open;
          this.mon.close = this.data1.close;
          this.mon.working = this.data1.working;
          this.data2 = this.seller.workingHour[2];
          this.tue.open = this.data2.open;
          this.tue.close = this.data2.close;
          this.tue.working = this.data2.working;
          this.data3 = this.seller.workingHour[3];
          this.wed.open = this.data3.open;
          this.wed.close = this.data3.close;
          this.wed.working = this.data3.working;
          this.data4 = this.seller.workingHour[4];
          this.thu.open = this.data4.open;
          this.thu.close = this.data4.close;
          this.thu.working = this.data4.working;
          this.data5 = this.seller.workingHour[5];
          this.fri.open = this.data5.open;
          this.fri.close = this.data5.close;
          this.fri.working = this.data5.working;
          this.data6 = this.seller.workingHour[6];
          this.sat.open = this.data6.open;
          this.sat.close = this.data6.close;
          this.sat.working = this.data6.working;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    edit() {
      var data = {};
      var workingHour = [];
      data["is24x7"] = this.is24x7;
      if (this.is24x7 == true) {
        data["is24x7"] = this.is24x7;
      } else {
        data["is24x7"] = this.is24x7;
        workingHour.push(this.sun);
        workingHour.push(this.mon);
        workingHour.push(this.tue);
        workingHour.push(this.wed);
        workingHour.push(this.thu);
        workingHour.push(this.fri);
        workingHour.push(this.sat);
        data["workingHour"] = workingHour;
      }
      // data["uid"] = this.uid;
      var arr = [];
      arr.push(this.categoryType);
      data["category"] = arr;
      data["subcategory"] = this.subcategoryType;
      if (this.restaurantType != null) {
        data["categorytype"] = this.restaurantType;
      }
      if (this.isBookingAvailable == true) {
        data["isBookingAvailable"] = this.isBookingAvailable;
        data["numberofChairs"] = this.numberofChairs;
      }
      axios({
        method: "POST",
        url: "seller/profile/level2",
        data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status == true) {
          this.msg = response.data.msg;
          this.showsnackbar = true;
          this.$emit("stepper", {
            level: 2,
          });
        } else {
          this.show = false;
          this.msg = response.data.msg;
          this.showsnackbar = true;
        }
      });
    },
  },
};
</script>
<style></style>
